var _style, _defs, _defs2, _rect, _defs3, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_4_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_6_);fill:#EBECEE;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#95A1A4;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 230,
    y: -142,
    width: 455,
    height: 300
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 455,
    height: 300,
    xlinkHref: "F96DD74AE3CDEF42.png",
    transform: "matrix(1 0 0 1 230 -142)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 230,
    y: -142,
    width: 455,
    height: 300
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -670,
    y: -132,
    className: "st0",
    width: 435,
    height: 280
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 240,
    y: -132,
    width: 435,
    height: 280
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: -137,
    className: "st1",
    width: 445,
    height: 290
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xD83C__xDFF7_-icon_x2F_bulk_x2F_gray"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(3.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    className: "st2",
    cx: -1.4,
    cy: 3.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy",
    className: "st2",
    cx: 2.9,
    cy: 3.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-2",
    className: "st2",
    cx: 7.1,
    cy: 3.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-3",
    className: "st2",
    cx: 5,
    cy: -1.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-6",
    className: "st2",
    cx: 9.3,
    cy: -1.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-5",
    className: "st2",
    cx: 11.4,
    cy: 3.2,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4-Copy-4",
    className: "st2",
    cx: 0.7,
    cy: -1.2,
    rx: 1.1,
    ry: 1.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulk);
export default __webpack_public_path__ + "static/media/bulk.e8d90ff7178bfa7a4e142da8de1b7ee5.svg";
export { ForwardRef as ReactComponent };